import React, { useState } from 'react';
import { Button, Tag, Carousel } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ShoppingOutlined, StarFilled, StarOutlined } from '@ant-design/icons';
import { IStoreDataAll } from './types';
import styles from './StoreListItem.module.scss';
import icon1 from '@/assets/images/Merchant _url.png';
import { useTranslation } from 'react-i18next';

interface StoreListItemProps {
	item: IStoreDataAll;
}

const StoreListItem: React.FC<StoreListItemProps> = ({ item }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	// 店铺信息
	const storeLogo: string = item?.merchant_logo_file_url || '';
	const storeName: string = item?.merchant_name
	// const followers: string = '28.07 Million Followers';
	// const positiveReviews: string = '100.00% Positive Reviews';
	// const repeatCustomers: string = '2 Million Repeat Customers Per Year';
	// const itemsSold: string = 'Over 300,000 Items Sold Per Month';
	// const shippingTime: string = 'Ships Within An Average Of 7 Hours';

	// 产品列表
	const products = item?.product_list || [];

	
	// 渲染星级评分
	const renderStars = (rating: number) => {
		const stars = [];
		for (let i = 1; i <= 5; i++) {
			if (i <= rating) {
				stars.push(<StarFilled key={i} className={styles.star} />);
			} else {
				stars.push(<StarOutlined key={i} className={styles.star} />);
			}
		}
		return stars;
	};

	// 产品轮播设置
	const carouselSettings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: true,
		// arrowSize:20,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	};

	return (
		<div className={styles['store-item']}>
			{/* 左侧店铺信息 */}
			<div className={styles['store-info']}>
				<div className={styles['store-header']}>
					<div className={styles['store-logo']}>
						<img src={storeLogo || icon1} alt={storeName} />
					</div>
					<div className={styles['store-details']}>
						<h3 className={styles['store-name']}>{storeName}</h3>
						{/* 评分暂时隐藏 */}
						{/* <div className={styles['store-rating']}>
							<span className={styles['rating-number']}>{storeRating}</span>
							<div className={styles['stars']}>
								{renderStars(storeRating)}
							</div>
						</div> */}
						{/* 评分暂时隐藏 */}
					</div>
				</div>

				<div className={styles['store-metrics']}>
					<div className={styles['metric-item']}>
						<span className={styles['metric-value']}>{t('searchList.followers')}</span>
					</div>
					<div className={styles['metric-item']}>
						<span className={styles['metric-value']}>{t('searchList.positiveReviews')}</span>
					</div>
				</div>

				<div className={styles['store-badges']}>
					{/* <Tag className={styles['badge']}>{repeatCustomers}</Tag> */}
					{/* <Tag className={styles['badge']}>{itemsSold}</Tag> */}
					<Tag className={styles['badge']}>{t('searchList.shippingTime')}</Tag>
				</div>
				<Button
					className={styles['enter-store-btn']}
					onClick={() => navigate(`/StoreDetail/${item?.merchant_id}`)}
				>
					<ShoppingOutlined />
					{t('searchList.EnterTheStore')}
				</Button>
			</div>

			{/* 右侧产品轮播 */}
			<div className={styles['product-carousel']}>
				<Carousel {...carouselSettings} className={styles['carousel']}>
					{products.map((product: any, index: number) => (
						// className={`${styles['product-card']} ${index === currentProductIndex ? styles['highlighted'] : ''}`
						<div
							key={index}
							className={`${styles['product-card']}`}
							onClick={() => navigate(`/ProductDetail/${product?.product_id}`)}
						>
							<div className={styles['product-image']}>
								<img src={product?.product_media_list[0]?.product_media_file_url} alt={`Product ${product.product_id}`} />
							</div>
							<div className={styles['product-info']}>
								<div className={styles['product-name']}>{product.product_title}</div>
								<div className={styles['price']}>${product.product_sku_values[0]?.product_price}</div>
							</div>
						</div>
					))}
				</Carousel>
			</div>
		</div>
	);
};

export default StoreListItem; 